import React from 'react';
import { Alert, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SummaryStatCard, { SummaryStatGrid } from '../common/SummaryStatCard';
import { payrollNetResult } from '../../utils/payrollNetResult';
import { BRAND } from '../../theme/brandTokens';

const PayrollProfitSummary = ({
  visible,
  filtered,
  storeGain,
  membershipMarginRetained,
  postedExpenses,
  currencyCode,
}) => {
  const { t } = useTranslation();

  if (!visible && !filtered) {
    return null;
  }

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 700, color: BRAND.primaryText, mb: 1 }}>
        {t('employeePayments.payroll.profit.title')}
      </Typography>
      {filtered ? (
        <Alert severity="info">{t('employeePayments.payroll.profit.filtered')}</Alert>
      ) : (
        <SummaryStatGrid>
          <SummaryStatCard
            label={t('employeePayments.payroll.totals.storeGain')}
            value={storeGain}
            currencyCode={currencyCode}
            emphasizeNegative
            tone="keep"
          />
          <SummaryStatCard
            label={t('expenses.payroll.expensesPaid')}
            value={postedExpenses}
            currencyCode={currencyCode}
            tone="cost"
          />
          <SummaryStatCard
            label={t('employeePayments.payroll.profit.amount')}
            value={payrollNetResult({
              storeGain,
              membershipMarginRetained,
              postedExpenses,
            })}
            currencyCode={currencyCode}
            emphasizeNegative
            tone="keep"
          />
        </SummaryStatGrid>
      )}
    </Box>
  );
};

export default PayrollProfitSummary;
